import { render, staticRenderFns } from "./TreasurerDashboard.vue?vue&type=template&id=0af20f37&scoped=true&"
import script from "./TreasurerDashboard.vue?vue&type=script&lang=js&"
export * from "./TreasurerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TreasurerDashboard.vue?vue&type=style&index=0&id=0af20f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af20f37",
  null
  
)

export default component.exports